const mpdata2020 = [
  {
    Roll: "15BEC010",
    Name: "Aditya r gupta",
    Project: "D2h based technology",
    Guide: "Dr. y.n. trivedi",
    Company: "Mcbs",
  },
  {
    Roll: "15BEC017",
    Name: "Anisha sanat unnithan",
    Project: "Intrusion detection system",
    Guide: "Dr. y. n. trivedi",
    Company: "Mcbs",
  },
  {
    Roll: "15BEC031",
    Name: "Dhruv panchal",
    Project: "Gain and phase analyzer",
    Guide: "Prof. bhavin kakani",
    Company: 'other',
  },
  {
    Roll: "15BEC085",
    Name: "Prajapati yamini bhupendrabhai",
    Project: "Intrusion detection system",
    Guide: "Dr. y. n. trivedi",
    Company: "Mcbs",
  },
  {
    Roll: "15BEC124",
    Name: "Vijekar tirth hemant",
    Project: 'NA',
    Guide: "Dr. dhaval shah",
    Company: "Inhouse",
  },
  {
    Roll: "15BEC156",
    Name: "Panchal vikas ajaykumar",
    Project: 'NA',
    Guide: "Prof. rutul patel ",
    Company: "Solulab",
  },
  {
    Roll: "15BEC166",
    Name: "Prajapati jaykumar shantilal",
    Project: "Virtual lab antenna design",
    Guide: "Dr. dhaval pujara",
    Company: "Inhouse",
  },
  {
    Roll: "15BEC181",
    Name: "Shah milap jayeshkumar",
    Project: "Product devlopment",
    Guide: "Dr. akash mecwan",
    Company: "Navkar treadcom",
  },
  {
    Roll: "16BEC001",
    Name: "Aayushmaan mazoomdar",
    Project: "Fleet management",
    Guide: "Dr. vaishali dhare",
    Company: "Evosys",
  },
  {
    Roll: "16BEC002",
    Name: "Maniar aayushi nirav ",
    Project:
      "Pnr flow of soc in alliance and checking feasibility of other open source tools",
    Guide: "Dr. piyush bhatasana",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC004",
    Name: "Abhishek  paliwal",
    Project: "Asic implementation for soc components at 28nm technology",
    Guide: "Dr. piyush bhatasana",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC005",
    Name: "Abhishek  soni",
    Project: "An ir diagnostic wrapper for pga and redhawk  ",
    Guide: "Dr. sachin gajjar",
    Company: "Arm embedded technologies",
  },
  {
    Roll: "16BEC006",
    Name: "Bajpai adhyan anil",
    Project: "Autonomous robot based delivery system",
    Guide: "Dr. dhaval shah",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC007",
    Name: "Parth sinha",
    Project: "Java based",
    Guide: "Dr. mangal singh",
    Company: "Cognizant",
  },
  {
    Roll: "16BEC008",
    Name: "Aditi  bhatnagar",
    Project: "Alexa voice integration for aws iot on psoc 6 board",
    Guide: "Dr. usha mehta",
    Company: "Cypress semiconductors",
  },
  {
    Roll: "16BEC009",
    Name: "Agravat mayur rajeshkumar",
    Project:
      "Development of analog trigger circuit for smartex-c plasma device",
    Guide: "Dr. akash mecwan",
    Company: "Ipr",
  },
  {
    Roll: "16BEC010",
    Name: "Agrawal shikha hitesh",
    Project: "Buildroot migration for odroid-c2 board",
    Guide: "Dr. d. k. kothari",
    Company: "Ebytelogic",
  },
  {
    Roll: "16BEC011",
    Name: "Ambasana kaushal shishirbhai",
    Project: "Study of process variation in semiconductor manufacturing",
    Guide: "Dr. n. p. gajjar",
    Company: "Nvidia graphics",
  },
  {
    Roll: "16BEC012",
    Name: "Arpit  tiwary",
    Project: "Spo2 measurement system design for wearable devices",
    Guide: "Dr. amisha naik",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC013",
    Name: "Ronal khara",
    Project: "Fleet management",
    Guide: "Dr. vaishali dhare",
    Company: "Evosys",
  },
  {
    Roll: "16BEC014",
    Name: "Poorva  gupta",
    Project: 'NA',
    Guide: "Dr. manisha upadhyay",
    Company: "Qualcomm",
  },
  {
    Roll: "16BEC015",
    Name: "Avantika  sharma",
    Project: "Application of deep learning",
    Guide: "Dr. ruchi gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC016",
    Name: "Babiya meet kishor",
    Project: "Spo2 measurement system design for wearable devices",
    Guide: "Dr. amisha naik",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC017",
    Name: "Prajapati ajaykumar vinaykumar",
    Project:
      "Development of analog trigger circuit for smartex-c plasma device",
    Guide: "Dr. akash mecwan",
    Company: "Ipr",
  },
  {
    Roll: "16BEC019",
    Name: "Prakhar   suneja",
    Project: "Verification of  armv8-r profile based core.",
    Guide: "Dr. sachin gajjar",
    Company: " arm embedded technologies",
  },
  {
    Roll: "16BEC020",
    Name: "Pranjal  shrivastava",
    Project: "Usb type-c pd authentication on ccgx usb controllers",
    Guide: "Dr. usha mehta",
    Company: "Cypress semiconductors",
  },
  {
    Roll: "16BEC021",
    Name: "Bodhanwala krishna kalpeshkumar",
    Project: "Human activity recognition using deep learning. ",
    Guide: "Prof. hardik joshi",
    Company: "L&t technology services",
  },
  {
    Roll: "16BEC022",
    Name: "Prateek kamal gyanchandani",
    Project: "Study ppa impact with ip characterization flow knobs",
    Guide: "Dr. sachin gajjar",
    Company: " arm embedded technologies",
  },
  {
    Roll: "16BEC023",
    Name: "Ms. chanchal   soni",
    Project: "Butler matrix based beamforming networking/ beam steering ",
    Guide: "Dr. dhaval pujara",
    Company: "Iit roorkee",
  },
  {
    Roll: "16BEC026",
    Name: "Rakshit  goyal",
    Project: "Verification and stress testing of arm v8 based cores",
    Guide: "Dr. sachin gajjar",
    Company: " arm embedded technologies",
  },
  {
    Roll: "16BEC027",
    Name: "Fulja oza ",
    Project: "Embedded system development for water dispensing sysyem",
    Guide: "Dr. akash mecwan",
    Company: "Resonent technolabs",
  },
  {
    Roll: "16BEC028",
    Name: "Ravi  mistry",
    Project: 'NA',
    Guide: "Dr. dhaval shah",
    Company: "Maharshi electronic systems",
  },
  {
    Roll: "16BEC029",
    Name: "Sangtani darshan jagdish ",
    Project: "Product development",
    Guide: "Dr. d. k. kothari",
    Company: "Zs associates",
  },
  {
    Roll: "16BEC030",
    Name: "Reshma  kandula",
    Project: 'NA',
    Guide: "Dr. tanish zaveri",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC031",
    Name: "Desai dhwani hetalbhai",
    Project: "Tentative: x injection in lbist",
    Guide: "Dr. manisha upadhyay",
    Company: "Qualcomm",
  },
  {
    Roll: "16BEC032",
    Name: "Desai vinay atulbhai",
    Project:
      "Juniper's core router ( ptx10001-36mr ) : understanding and validating 400g interfaces ",
    Guide: "Dr. dhaval shah",
    Company: "Juniper networks ",
  },
  {
    Roll: "16BEC033",
    Name: "Sinha devanshi  sanjeev  ",
    Project: "Development of single board cca test system",
    Guide: "Dr. manisha upadhyay",
    Company: "Secure meters",
  },
  {
    Roll: "16BEC034",
    Name: "Sarthak  seth",
    Project: "4g coverage optimization\n",
    Guide: "Dr. ruchi gajjar",
    Company: "Nokia network solutions",
  },
  {
    Roll: "16BEC035",
    Name: "Dhruv  mathur",
    Project: "4g coverage optimization",
    Guide: "Dr. ruchi gajjar",
    Company: "Nokia network solutions",
  },
  {
    Roll: "16BEC036",
    Name: "Saumya thacker",
    Project: "Soc verification",
    Guide: "Dr. vijay savani",
    Company: "Eximius design",
  },
  {
    Roll: "16BEC037",
    Name: "Divyanshu  tak",
    Project:
      "Generation of polarization entangled photon pair using ppktp crystal at 405nm wavelength through type-0 matching and spdc process ",
    Guide: "Dr. dhaval pujara",
    Company: "Prl",
  },
  {
    Roll: "16BEC038",
    Name: "Shashank khemka",
    Project: "Plant disease detection using drone",
    Guide: "Dr. n. p. gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC039",
    Name: "Thakkar hardi bhargavbhai ",
    Project: 'NA',
    Guide: "Prof. dipesh panchal",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC040",
    Name: "Shivang  dalal",
    Project: "Iiot, information management, data analysis and automation",
    Guide: "Prof. twinkle bhavsar",
    Company: "Eronkan technologies",
  },
  {
    Roll: "16BEC041",
    Name: "Heli sanjay kolambekar",
    Project: "Intelligent video analytics for security systems",
    Guide: "Prof. bhavin kakani",
    Company: "Matrix comsec",
  },
  {
    Roll: "16BEC042",
    Name: "Shivani patel",
    Project: "Solar panel based smart grid system",
    Guide: "Prof. rachna sharma",
    Company: "Strautx technologies",
  },
  {
    Roll: "16BEC044",
    Name: "Herin shah",
    Project: "Plant disease detection using drone",
    Guide: "Dr. n. p. gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC045",
    Name: "Shreejita chaudhuri",
    Project: "Smart parking system",
    Guide: "Dr. vaishali dhare",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC046",
    Name: "Ishan  lakhwani",
    Project: "Training",
    Guide: "Prof. hardik joshi",
    Company: "Snaxsmart",
  },
  {
    Roll: "16BEC047",
    Name: "Shreya  adhikari",
    Project: "Incentive compensation of sales reps",
    Guide: "Dr. d. k. kothari",
    Company: "Zs associates",
  },
  {
    Roll: "16BEC048",
    Name: "Ms. ishita  kumawat",
    Project: "Voice communication over a zigbee network",
    Guide: "Dr. bhupendra fataniya",
    Company: "J k laxmi cement",
  },
  {
    Roll: "16BEC049",
    Name: "Shreyansh  nayak",
    Project:
      "Vehicle number plate recognition system with the help of image processing",
    Guide: "Dr. bhupendra fataniya",
    Company: "J k laxmi cement",
  },
  {
    Roll: "16BEC051",
    Name: "Shreyansh  surana",
    Project: 'NA',
    Guide: "Dr. mangal singh",
    Company: "Cognizant",
  },
  {
    Roll: "16BEC052",
    Name: "Jahnvi bedia",
    Project: "Training",
    Guide: "Dr. y. n. trivedi",
    Company: "Dosepack",
  },
  {
    Roll: "16BEC053",
    Name: "Simran  kathuria",
    Project: 'NA',
    Guide: "Dr. vaishali dhare",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC054",
    Name: "Jainam  lakhtaria",
    Project: "Android developement for iot applications",
    Guide: "Dr. vijay savani",
    Company: "Hidden brains",
  },
  {
    Roll: "16BEC055",
    Name: "Somil  kabra",
    Project: "Market segmentation",
    Guide: "Dr. d. k. kothari",
    Company: "Zs associates",
  },
  {
    Roll: "16BEC056",
    Name: "Jaya  thadhani",
    Project: "Analog blocks design for memories",
    Guide: "Dr. tanish zaveri",
    Company: "Xilinx, hyderabad",
  },
  {
    Roll: "16BEC057",
    Name: "Sujaan  dubey",
    Project: "Development of ares mechanical software",
    Guide: "Prof. bhavin kakani",
    Company: "Graebert india software",
  },
  {
    Roll: "16BEC058",
    Name: "Jayvik desai",
    Project: "Multiplayer lan game and wifi device integration with psoc-6",
    Guide: "Dr. usha mehta",
    Company: "Cypress semiconductors",
  },
  {
    Roll: "16BEC059",
    Name: "Swastika  dash",
    Project: "Chest disease classification from x-rays using deep learning ",
    Guide: "Dr. tanish zaveri",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC060",
    Name: "Saket lunker",
    Project: "Software development (multiple projects)",
    Guide: "Prof. hardik joshi",
    Company: "L&t",
  },
  {
    Roll: "16BEC062",
    Name: "Jethva monil jayeshbhai",
    Project: "Recorder application using live555 and ffmpeg",
    Guide: "Dr. manish patel",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC063",
    Name: "Jethwa himang kishorbhai",
    Project: 'NA',
    Guide: "Dr. mangal singh",
    Company: "Cognizant",
  },
  {
    Roll: "16BEC064",
    Name: "Uttkarsh dinesh tak",
    Project:
      "Embedded system development for wireless health monitoring devices",
    Guide: "Prof. rachna sharma",
    Company: "Avantari technologies pvt. ltd.",
  },
  {
    Roll: "16BEC065",
    Name: "Jobanputra ami",
    Project: "Uhf circulator",
    Guide: "Dr. dhaval pujara",
    Company: "Sac-isro",
  },
  {
    Roll: "16BEC066",
    Name: "Vakharia anshul rajan",
    Project: "Image processing based quality control system",
    Guide: "Prof. rachna sharma",
    Company: "Eagle international",
  },
  {
    Roll: "16BEC067",
    Name: "Kadia harshil vinodkumar",
    Project: "Smart parking system",
    Guide: "Prof. rachna sharma",
    Company: "Synoverge",
  },
  {
    Roll: "16BEC068",
    Name: "Vatsal  sompura",
    Project: "Solar station and profile probe design",
    Guide: "Prof. twinkle bhavsar",
    Company: "Neerx technovation",
  },
  {
    Roll: "16BEC069",
    Name: "Kanojiya manavkumar mahendrabhai",
    Project: 'Asic implementation for soc components at 28nm technology".',
    Guide: "Dr. manish patel",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC070",
    Name: "Vidhi shah",
    Project: 'Asic implementation for soc components at 28nm technology".\n',
    Guide: "Prof. twinkle bhavsar",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC071",
    Name: "Karan bhavesh shah",
    Project: " ai",
    Guide: "Dr. tanish zaveri",
    Company: "Intel",
  },
  {
    Roll: "16BEC072",
    Name: "Vikani purval kishorbhai",
    Project:
      "Design generic synthesizable multiplier & accumulator rtl in verilog ",
    Guide: "Prof. dipesh panchal",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC073",
    Name: "Karan shah",
    Project: "Verification of hubs for smartnic",
    Guide: "Dr. akash mecwan",
    Company: "Xilinx, delhi",
  },
  {
    Roll: "16BEC074",
    Name: "Karnik  gupta",
    Project: "Smart card based security system",
    Guide: "Prof. twinkle bhavsar",
    Company: "Symphony limited",
  },
  {
    Roll: "16BEC075",
    Name: "Yash lad",
    Project: "Product management in ip video surveillance",
    Guide: "Prof. bhavin kakani",
    Company: "Matrix comsec",
  },
  {
    Roll: "16BEC076",
    Name: "Naman khandelwal",
    Project: "Performance analysis of xilinx versal architecture. ",
    Guide: "Dr. tanish zaveri",
    Company: "Xilinx, hyderabad",
  },
  {
    Roll: "16BEC077",
    Name: "Priti khandelwal",
    Project: "Sv unit testing of arm architecture",
    Guide: "Dr. sachin gajjar",
    Company: " arm embedded technologies",
  },
  {
    Roll: "16BEC079",
    Name: "Keshavkant sharma",
    Project: "Vision framework for surveillance ",
    Guide: "Prof. bhavin kakani",
    Company: "Enercomp solutions",
  },
  {
    Roll: "16BEC080",
    Name: "Yogesh  maheshwari",
    Project: "Dl based regressor for graphics power predictor logic",
    Guide: "Dr. n. p. gajjar",
    Company: "Nvidia",
  },
  {
    Roll: "16BEC081",
    Name: "Kuhuk narain",
    Project: "Verification of vips",
    Guide: "Dr. vaishali dhare",
    Company: "Mentor graphics",
  },
  {
    Roll: "16BEC082",
    Name: "Mahesh chandak",
    Project: "Incentive compensation of sales representative",
    Guide: "Dr. d. k. kothari",
    Company: "Zs associates",
  },
  {
    Roll: "16BEC083",
    Name: "Makwana mehul pravinbhai",
    Project: "Tire pressure monitoring system",
    Guide: "Prof. rutul patel ",
    Company: "Bisag",
  },
  {
    Roll: "16BEC084",
    Name: "Makwana shreeya kiritbhai",
    Project:
      "Virtual output queues architecture to improve interconnect throughput.",
    Guide: "Prof. hardik joshi",
    Company: "Provino technologies",
  },
  {
    Roll: "16BEC085",
    Name: "Punit  malpani",
    Project: "Smart fire detection system",
    Guide: "Dr. piyush bhatasana",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC086",
    Name: "Maru kapilkumar parbatbhai",
    Project: "Tire pressure monitoring system",
    Guide: "Prof. rutul patel ",
    Company: "Bisag",
  },
  {
    Roll: "16BEC087",
    Name: "Mehta meet kirankumar",
    Project: "Building dmm for pathwave",
    Guide: "Dr. manish patel",
    Company: "Keysight",
  },
  {
    Roll: "16BEC088",
    Name: "Mishra saurabh sushil",
    Project:
      "Controlling of device through voice recognition using matlab/simulink.",
    Guide: "Dr. piyush bhatasana",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC090",
    Name: "Miti shah",
    Project: "Accident avoidance system",
    Guide: "Dr. manisha upadhyay",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC091",
    Name: "Modasiya mohmed safin mohmed yusuf",
    Project: "Accident avoidance system",
    Guide: "Dr. manisha upadhyay",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC092",
    Name: "Modi parth ketankumar",
    Project: "Applications of deep learning",
    Guide: "Dr. ruchi gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC093",
    Name: "Mohamad abrar i mansuri",
    Project:
      "Implementing and tracking of goods from packaging from the suppliers to consumers",
    Guide: "Dr. sachin gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC094",
    Name: "Muskan  porwal",
    Project:
      "Implementation of low power axi4 stream master and slave bridges for interconnect in socs",
    Guide: "Prof. hardik joshi",
    Company: "Provino technologies\n",
  },
  {
    Roll: "16BEC095",
    Name: "Naman  goyal",
    Project: "Home automation system using bluetooth low energy",
    Guide: "Dr. dhaval shah",
    Company: "Corefragment\n",
  },
  {
    Roll: "16BEC096",
    Name: "Nitesh  kalwani",
    Project: "Mentor embedded linux omni os upgradation and testing",
    Guide: "Dr. vaishali dhare",
    Company: "Mentor graphics, bangalore",
  },
  {
    Roll: "16BEC097",
    Name: "Onima pandit",
    Project: "Fake news detector",
    Guide: "Prof. twinkle bhavsar",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC098",
    Name: "Oshin  bansal",
    Project: "Ai in web technologies",
    Guide: "Prof. rachna sharma ",
    Company: "Atlassoftweb",
  },
  {
    Roll: "16BEC099",
    Name: "Oza vatsal",
    Project: "Fake news detector",
    Guide: "Prof. twinkle bhavsar",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC100",
    Name: "Pandya shiven hiteshbhai",
    Project: "Bluetooth controller firmware",
    Guide: "Dr. usha mehta",
    Company: "Cypress semiconductor ",
  },
  {
    Roll: "16BEC101",
    Name: "Rahul bansal",
    Project: " attendance system using face recognization",
    Guide: "Prof. rutul patel ",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC102",
    Name: "Ayush jain",
    Project: "Iot on beaglebone platform",
    Guide: "Dr. manish patel",
    Company: "Einfochips ",
  },
  {
    Roll: "16BEC103",
    Name: "Stuti v garg",
    Project: "Robotics",
    Guide: "Dr. manisha upadhyay",
    Company: "Iisc bangalore",
  },
  {
    Roll: "16BEC104",
    Name: "Sparsh yashlaha",
    Project: "Google cloud platform practioner based projects",
    Guide: "Dr. bhupendra fataniya",
    Company: "Searce",
  },
  {
    Roll: "16BEC105",
    Name: "Arya pranjal vedruchibhai",
    Project: "Driver development for arm cortex-m33 based mcu",
    Guide: "Dr. usha mehta",
    Company: "Cypress semiconductors",
  },
  {
    Roll: "16BEC106",
    Name: "Issrani muskan darshan kumar",
    Project:
      "Implementing and tracking of goods from packaging from the suppliers to consumers",
    Guide: "Dr. sachin gajjar",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC107",
    Name: "Amin prerak ashish",
    Project:
      "Learn basics of somachine for plc designing for automating machines",
    Guide: "Dr. piyush bhatasana",
    Company: "Fast track inc.",
  },
  {
    Roll: "16BEC108",
    Name: "Meet m patel",
    Project: 'NA',
    Guide: "Dr. mangal singh",
    Company: "Cognizant",
  },
  {
    Roll: "16BEC109",
    Name: "Anmol jain",
    Project: "Amazon web service  : cloud spent and optimization",
    Guide: "Dr. bhupendra fataniya",
    Company: "Searce",
  },
  {
    Roll: "16BEC110",
    Name: "Patel rutvik bipinchandra",
    Project: "Rotary device for laser technology ",
    Guide: "Prof. rachna sharma",
    Company: "Sahajanand laser technology ltd.",
  },
  {
    Roll: "16BEC111",
    Name: "Utkarsh sunil agrawal",
    Project: "Dev2oci migration",
    Guide: "Dr. n. p. gajjar",
    Company: "Oracle",
  },
  {
    Roll: "16BEC112",
    Name: "Gursimar hora",
    Project: "Automated attendance system using facial recogition",
    Guide: "Prof. rutul patel ",
    Company: "Inhouse",
  },
  {
    Roll: "16BEC113",
    Name: "Kamya ahuja",
    Project: "Asic implementation for soc components at 90nm technology",
    Guide: "Dr. manish patel",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC115",
    Name: "Rinali dipenbhai shah",
    Project:
      "Design synthesizable spi master and slave, rtl as per standard specification & self checking testbench in verilog with coverage closure\u201d",
    Guide: "Dr. amisha naik",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC116",
    Name: "Vithika mandhwani",
    Project: "Unified server modelling for navic based navigation solutions",
    Guide: "Dr. dhaval pujara",
    Company: "Sac isro",
  },
  {
    Roll: "16BEC117",
    Name: "Mengar ronak deepakbhai",
    Project: "Microcontroller based  power delivering system development",
    Guide: "Dr. ruchi gajjar",
    Company: "Beehive congruence",
  },
  {
    Roll: "16BEC118",
    Name: "Ramnani vinita jagdish",
    Project: "Smartnic hub testing and verification",
    Guide: "Dr. tanish zaveri",
    Company: "Xilinx, delhi",
  },
  {
    Roll: "16BEC119",
    Name: "Patel nishith nileshkumar",
    Project:
      "Uart tx & rx synthesizable design & testbench",
    Guide: "Dr. amisha naik",
    Company: "E-infochips",
  },
  {
    Roll: "16BEC120",
    Name: "Patel meet manojkumar",
    Project: "Asic implementation for soc components at 90nm technology",
    Guide: "Dr. amisha naik",
    Company: "E-infochips",
  },
  {
    Roll: "16BEC121",
    Name: "Amipara parth rameshbhai",
    Project: "Analysis of throughput using trx and prx (data analytics)",
    Guide: "Dr. n. p. gajjar",
    Company: "Samsung",
  },
  {
    Roll: "16BEC122",
    Name: "Talwar vivek jayant",
    Project:
      " comparing multi-armed bandit algorithms and a/b testing methonds on digital marketing use-cases",
    Guide: "Dr. ruchi gajjar",
    Company: "Merkle sokrati",
  },
  {
    Roll: "16BEC123",
    Name: "Nitin sharma",
    Project:
      "Develop i2s protocol compliant transmitter and receiver synthesizable rtl as per standard specification & self-checking testbench environment in verilog with code coverage closure",
    Guide: "Dr. amisha naik",
    Company: "E-infochips",
  },
  {
    Roll: "16BEC124",
    Name: "Bhatt mauli sanjaykumar",
    Project: "Temperature controller",
    Guide: "Dr. dhaval shah",
    Company: "Accunova",
  },
  {
    Roll: "16BEC125",
    Name: "Akhilesh sivadasan",
    Project:
      "Speaker identification and audio fingerprinting using neural network",
    Guide: "Prof. hardik joshi",
    Company: "L&t technology services",
  },
  {
    Roll: "16BEC126",
    Name: "Devika muley",
    Project:
      "Design dma controller synthesizable rtl using verilog and write verilog testbench to achieve 100 percent design code coverage",
    Guide: "Prof. dipesh panchal",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC127",
    Name: "Bharat aasija",
    Project: "Microsoft sql server ",
    Guide: "Dr. y. n. trivedi",
    Company: "Intellytics solutions",
  },
  {
    Roll: "16BEC129",
    Name: "Candy brendon james",
    Project: "Selenium automation testing",
    Guide: "Dr. mangal singh",
    Company: "Cognizant",
  },
  {
    Roll: "16BEC130",
    Name: "Pancholi mrunal nileshkumar",
    Project:
      "Develop amba 2.0 compliant ahb to apb synthesizable rtl in verilog and develop it s verification environment in verilog",
    Guide: "Prof. dipesh panchal",
    Company: "Einfochips",
  },
  {
    Roll: "16BEC160",
    Name: "Nayak laksh harshad",
    Project: "Variable frequency drives for industrial applications",
    Guide: "Prof. dipesh panchal",
    Company: "Premier electronic services",
  },
  {
    Roll: "16BEC162",
    Name: "Panchal bhoomit mukesh",
    Project:
      "Wiring harness desgin for hopper loader and injection moulding machines",
    Guide: "Dr. vijay savani",
    Company: "Swift auxi technik pvt ltd",
  },
  {
    Roll: "16BEC174",
    Name: "Saluja karan sanjay",
    Project: "Vfd for  industrial application",
    Guide: "Prof. dipesh panchal",
    Company: "Premier electronic services",
  },
  {
    Roll: "16BEC177",
    Name: "Solanki mehulkumar ishvarbhai",
    Project: "D2h based technology",
    Guide: "Dr. y. n. trivedi",
    Company: "Mcbs",
  },
  {
    Roll: "16BEC178",
    Name: "Sumbhe ronak pravin",
    Project: "Tech. support trainee",
    Guide: "Dr. vijay savani",
    Company: "Eximius network solutions",
  },
  {
    Roll: "16BEC181",
    Name: "Vaniya hardik bhanuprasad",
    Project: "Detection of artificially ripened fruits",
    Guide: "Dr. bhupendra fataniya",
    Company: "Inhouse",
  },
];


export default mpdata2020;